import React, { useEffect, useState } from "react";
import { Popup } from "semantic-ui-react";
import CreateMcq from "./CreateMcq";
import CreateUploadType from "./CreateUploadType";
import CreatePopup from "./CreatePopup";
import axios from "../../axios";
import Guides from "./Guides";
import { useDispatch, useSelector } from "react-redux";
import ComponentType from "../../Enum/ComponentTypeEnum";
import CheckValidationInput from "./CheckValidationInput";
import { Info } from "lucide-react";
import { IP } from "../../internalServer";
import { iconData } from "../../iconData";
import assets from "../../assets/assets";
import QuestionTypePopup from "./QuestionTypePopup";
import PdfViewer from "./PdfViewer";
import {
  ChevronDown,
  Trash2,
  MoreVertical,
  FileText,
  Award,
  BarChart3,
} from "lucide-react";
import { hasDescriptiveAutoAssessment } from "../../Utils/features";
const DefaultQuestion = ({
  componentType,
  nextQuestion,
  question,
  setQuestions,
  assessmentDetails,
  qArr,
  showErrorInputField,
  setShowErrorInputField,
  getErrorMsg,
  chapter,
  selectedBox,
  isActive,
  onToggle,
  questionType,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  console.log(question, "questions");

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const skillsData = useSelector((state) => state.initialData.skills);

  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState("");
  const domainsData = useSelector((state) => state.initialData.domain);
  const [fLimit, setFLimit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [addquestion, setAddQuestion] = useState("");
  const [click, setClick] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [dropdownList, setDropdownList] = useState({
    skills: skillsData,
    types: questionType,
    domains: null,
    chapters: chapter,
    difficultyLevels: difficulty_levelData,
  });
  const { skills, types, domains, chapters, difficultyLevels } = dropdownList;
  const [zoomedAttachment, setZoomedAttachment] = useState(false);
  const [openQuestionsPopup, setOpenQuestionsPopup] = useState(false);

  useEffect(() => {
    setDropdownList({
      skills: skillsData,
      types: questionType,
      domains: domainsData,
      chapters: chapter, // 🔥 FIX
      difficultyLevels: difficulty_levelData,
    });
  }, [skillsData, questionType, domainsData, difficulty_levelData, chapter]);

  const skillToDomainNameMap = {
    Remember: "Factual",
    Understand: "Conceptual",
    Apply: "Conceptual",
    Analyze: "Procedural",
    Evaluate: "Metacognitive",
    Create: "Metacognitive",
    None: "None",
  };

  const domainNameToIdMap = Object.fromEntries(
    Array.isArray(domains) ? domains.map((d) => [d.name, d.id]) : [],
  );

  const skillsWithDomainId =
    Array.isArray(skills) &&
    skills.map((skill) => {
      const domainName = skillToDomainNameMap[skill.name];
      const domainId = domainNameToIdMap[domainName] || null;

      return {
        ...skill,
        domain_id: domainId,
      };
    });
  const validateFileType = (file) => {
    // ✅ Conditional allowed extensions
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf|\.doc|\.docx|\.txt)$/i;

    if (
      !allowedExtensions.test(file.name) ||
      question?.attachments?.length > 5
    ) {
      setIsValidFileType(false);
      return false;
    }

    setIsValidFileType(true);
    return true;
  };

  const handleAttachment = async (files) => {
    if (!files || files.length === 0) return;

    const file = files[0];

    // if (!file.type.startsWith("image/")) {
    //   toast.error("Only image files are allowed!");
    //   return;
    // }

    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
      setFLimit(true);
      return;
    }

    if (validateFileType(file)) {
      try {
        setLoader(true);
        let formData = new FormData();
        formData.append("name", file.name);
        formData.append("uploadQuestionAttachment", file);

        let res = await axios.post(
          `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
          formData,
        );

        const attachments_sizeKb = [Math.round(file.size / 1024)];
        const attachments = [res.data.data];

        res && setFLimit(false);
        setLoader(false);

        if (attachments.length > 0) {
          setQuestions((prev) => {
            const updatedQuestion = {
              ...prev[nextQuestion],
              is_question_edited: true,
              attachments: [
                ...(prev[nextQuestion].attachments || []),
                ...attachments,
              ],

              attachments_sizeKb,
            };
            const newQuestion = [...prev];
            newQuestion[nextQuestion] = updatedQuestion;
            return newQuestion;
          });
        }
      } catch (error) {
        console.log(error);
        setLoader(false);
      }
    }
  };

  const checkRemoveAttachmentisFromLibrary = (attachment, idx) => {
    if (question.id) {
      handleSoftDeleteAttachment(attachment, idx);
    } else {
      handleRemoveAttachment(attachment, idx);
    }
  };

  const handleSoftDeleteAttachment = (attachment, idx) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const filteredAttachments = updated[nextQuestion].attachments.filter(
        (_, i) => i !== idx,
      );
      updated[nextQuestion] = {
        ...updated[nextQuestion],
        attachments: filteredAttachments,
        is_question_edited: true,
      };
      return updated;
    });
  };

  const handleRemoveAttachment = async (attachmentToRemove, idx) => {
    try {
      const filePath = attachmentToRemove?.url || attachmentToRemove;

      const res = await axios.delete(`/api/v1/file/delete`, {
        data: { file_path: filePath },
      });

      if (res) {
        setQuestions((prev) => {
          const updated = [...prev];

          const filteredAttachments = updated[nextQuestion].attachments.filter(
            (_, i) => i !== idx,
          );
          updated[nextQuestion] = {
            ...updated[nextQuestion],
            attachments: filteredAttachments,
            is_question_edited: true,
          };
          return updated;
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Warn user if they attempt to navigate away with unsaved changes

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (unsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [unsavedChanges]);

  const handleClickforpdf = (fileUrl) => {
    setResponseAttach(fileUrl);
    setMideaviewer(true);
  };

  const removeQuestion = (questionIndex) => {
    setQuestions((prev) => prev.filter((_, i) => i !== questionIndex));
  };

  return (
    <>
      {/* Thick top line with 3 dots underneath */}
      <div className="position-relative mb-1 mt-2">
        {/* Thick brown horizontal line */}
        <hr
          className="m-0"
          style={{
            borderTop: "4px solid #D3D3D3",
            opacity: 1, // ensure it's visible
          }}
        />
      </div>
      <div
        className="d-flex align-items-center justify-content-center  "
        style={{ width: "100%" }}
      >
        <div className=" p-3" style={{ width: "90%" }}>
          <div className="d-flex align-items-center justify-content-between gap-3">
            {/* Main Collapsible Header */}
            <div
              onClick={onToggle}
              className="question-card-header flex-grow-1 position-relative overflow-hidden"
              style={{
                cursor: "pointer",
                background: isActive
                  ? "linear-gradient(135deg, #FFF8F0 0%, #FFECD2 100%)"
                  : "linear-gradient(135deg, #FFFBF7 0%, #FFF5E6 100%)",
                borderRadius: "16px",
                padding: "16px 20px",
                boxShadow: isActive
                  ? "0 8px 24px rgba(141, 75, 40, 0.12), inset 0 1px 0 rgba(255,255,255,0.8)"
                  : "0 4px 16px rgba(141, 75, 40, 0.06), inset 0 1px 0 rgba(255,255,255,0.6)",
                border: isActive
                  ? "2px solid #E07C24"
                  : "1px solid rgba(141, 75, 40, 0.15)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              {/* Decorative Circle */}
              <div
                className="position-absolute"
                style={{
                  top: "-20px",
                  right: "-20px",
                  width: "80px",
                  height: "80px",
                  background:
                    "radial-gradient(circle, rgba(224, 124, 36, 0.08) 0%, transparent 70%)",
                  borderRadius: "50%",
                  pointerEvents: "none",
                }}
              />

              <div className="d-flex justify-content-between align-items-center position-relative">
                {/* Left: Question Number & Title */}
                <div
                  className="d-flex align-items-center gap-3"
                  style={{ flex: 1, minWidth: 0 }}
                >
                  {/* Question Badge */}
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      background: isActive
                        ? "linear-gradient(135deg, #E07C24 0%, #D35400 100%)"
                        : "linear-gradient(135deg, #F4A261 0%, #E07C24 100%)",
                      color: "white",
                      borderRadius: "12px",
                      padding: "8px 14px",
                      fontWeight: 700,
                      fontSize: "14px",
                      boxShadow: "0 4px 12px rgba(224, 124, 36, 0.25)",
                      flexShrink: 0,
                    }}
                  >
                    Q{nextQuestion + 1}
                  </div>

                  {/* Question Title & Meta */}
                  <div
                    className="text-truncate"
                    style={{ flex: 1, minWidth: 0 }}
                  >
                    <div
                      className="text-truncate"
                      style={{
                        fontSize: "15px",
                        fontWeight: 600,
                        color: isActive ? "#8D4B28" : "#5D4037",
                        letterSpacing: "-0.2px",
                      }}
                    >
                      {question?.title || "Please Add Title "}
                    </div>

                    {/* Meta Info */}
                    <div
                      className="d-flex align-items-center gap-2"
                      style={{
                        fontSize: "12px",
                        color: "#A67B5B",
                        marginTop: "3px",
                      }}
                    >
                      <span className="d-flex align-items-center gap-1">
                        <FileText size={12} />
                        {types?.find((t) => t.id === question?.type_id)?.name ||
                          "No type"}
                      </span>

                      {question?.correct_score ? (
                        <>
                          <span style={{ color: "#D4A574" }}>•</span>
                          <span className="d-flex align-items-center gap-1">
                            <Award size={12} />
                            {question.correct_score} marks
                          </span>
                        </>
                      ) : null}

                      {question?.difficulty_level && (
                        <>
                          <span style={{ color: "#D4A574" }}>•</span>
                          <span
                            className="d-flex align-items-center gap-1"
                            style={{
                              padding: "1px 6px",
                              background: "rgba(224, 124, 36, 0.1)",
                              borderRadius: "4px",
                              fontSize: "11px",
                            }}
                          >
                            <BarChart3 size={10} />
                            {difficultyLevels?.find(
                              (d) => d.id === question.difficulty_level,
                            )?.name || "Level"}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Right: Chevron */}
                <div
                  className="d-flex align-items-center justify-content-center ms-3"
                  style={{
                    transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    color: isActive ? "#E07C24" : "#A67B5B",
                  }}
                >
                  <ChevronDown size={24} strokeWidth={2.5} />
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex align-items-center gap-2">
              {/* Delete Button */}
              {qArr && qArr.length > 0 && (
                <button
                  className="btn p-0 border-0"
                  onClick={(e) => {
                    e.stopPropagation();

                    removeQuestion(nextQuestion);
                  }}
                  style={{
                    background:
                      "linear-gradient(135deg, #FFF5F5 0%, #FFE5E5 100%)",
                    border: "1px solid rgba(220, 53, 69, 0.2) !important",
                    borderRadius: "12px",
                    padding: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 8px rgba(220, 53, 69, 0.08)",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(135deg, #FFE5E5 0%, #FFD5D5 100%)";
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background =
                      "linear-gradient(135deg, #FFF5F5 0%, #FFE5E5 100%)";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                  title="Delete Question"
                >
                  <Trash2 size={20} color="#DC3545" />
                </button>
              )}
            </div>
          </div>

          {isActive && (
            <div>
              {/* Question text area and attachment */}
              <div className=" d-flex align-items-center justify-content-between w-100  gap-2">
                <textarea
                  className="rounded-4 mt-2 p-2"
                  style={{ width: "85%" }}
                  placeholder="Add Question"
                  id="questiontitle"
                  rows="3"
                  // Because of "question.title" I am able to write special character prevent this issue I added state
                  value={question.title ? question.title : addquestion}
                  onChange={(e) => {
                    const value = e.target.value;
                    setUnsavedChanges(true);

                    // I allow some special character for question input field
                    setAddQuestion(value);
                    setQuestions((prev) => {
                      const updatedQuestion = {
                        ...prev[nextQuestion],
                        title: value,
                        is_question_edited: true,
                      };
                      const newQuestion = [...prev];
                      newQuestion[nextQuestion] = updatedQuestion;
                      return newQuestion;
                    });
                  }}
                ></textarea>

                <div
                  className=" h-100"
                  style={{ width: "15%", overflowX: "scroll" }}
                >
                  <div className="h-100 d-flex align-items-center flex-wrap justify-content-center orange-scrollBar">
                    {(!question?.attachments ||
                      question.attachments.length === 0) &&
                      !loader && (
                        <>
                          <input
                            onChange={(e) => {
                              handleAttachment(e.target.files);
                            }}
                            //only accepting images right now
                            // accept=".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .jpg, .jpeg, .gif, .png, .mp3, .aac, .mp4, .mov, .wmv, .mpeg"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            type="file"
                            id={`attachFile${nextQuestion}`}
                            style={{ display: "none" }}
                          />
                          <label
                            htmlFor={`attachFile${nextQuestion}`}
                            style={{
                              border: "1px solid #8D4B28",
                              color: "#8D4B28",
                              backgroundColor: "white",
                            }}
                            className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold mt-2"
                          >
                            <img
                              src={assets.UploadIcon}
                              height="100%"
                              width="45px"
                              alt="Attach Icon"
                              style={{
                                objectFit: "contain", // ensures proper scaling
                                maxHeight: "100%", // keep it within label height
                              }}
                            />
                          </label>
                        </>
                      )}

                    {loader && (
                      <img
                        style={{ width: "32px", height: "32px" }}
                        src="/gif/Loader.gif"
                        alt="Loading"
                      />
                    )}
                    <span
                      style={{ color: "red", width: "100%", fontSize: "10px" }}
                    >
                      {fLimit && "Max file size: 10 MB "}
                    </span>

                    {/* {question?.attachments?.length > 0 &&
                  question.attachments.map((attachment, idx) => (
                    <CrossAttachmentAssessment
                      key={idx}
                      attachment={attachment}
                      isEditable={true}
                      setQuestions={setQuestions}
                      nextQuestion={nextQuestion}
                    />
                  ))} */}

                    {question?.attachments?.length > 0 &&
                      question.attachments.map((attachment, idx) => {
                        const fileUrl =
                          typeof attachment === "string"
                            ? attachment
                            : attachment?.url;

                        if (!fileUrl) return null;

                        const fileType = fileUrl.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(
                          fileType,
                        );
                        const isVideo = ["mp4", "mov"].includes(fileType);
                        const isPdf = ["pdf"].includes(fileType);

                        const fileIcon =
                          iconData?.find((i) => i.extension === fileType)
                            ?.icon || "";

                        const fullUrl = fileUrl.startsWith("http")
                          ? fileUrl
                          : `${IP}${fileUrl}`;

                        return (
                          <div
                            key={idx}
                            className="d-flex flex-rows align-items-center me-3 "
                          >
                            {isImage ? (
                              <img
                                src={fullUrl}
                                alt="attachment"
                                onClick={() =>
                                  setZoomedAttachment(`${IP}${fileUrl}`)
                                }
                                style={{
                                  width: "80px",
                                  height: "70px",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                  marginBottom: "5px",
                                }}
                              />
                            ) : isVideo ? (
                              <video
                                src={fileUrl}
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  borderRadius: "6px",
                                  marginBottom: "5px",
                                }}
                                controls
                              />
                            ) : isPdf ? (
                              <div
                                onClick={() => handleClickforpdf(fileUrl)}
                                style={{
                                  width: "125px",
                                  height: "80px",
                                  background: "#f5f5f5",
                                  borderRadius: "6px",
                                  marginBottom: "5px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={fileIcon}
                                  alt="pdf"
                                  style={{ width: "40px", height: "40px" }}
                                />
                                <div className="hw_default_attach_name">
                                  <span>
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <a
                                href={`https://docs.google.com/gview?url=${encodeURIComponent(
                                  IP + fileUrl,
                                )}&embedded=true`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none" }}
                              >
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "125px",
                                    height: "80px",
                                    background: "#f5f5f5",
                                    borderRadius: "6px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <img
                                    src={fileIcon}
                                    alt="file icon"
                                    style={{ width: "40px", height: "40px" }}
                                  />
                                  <div className="hw_default_attach_name">
                                    <span>
                                      {attachment?.replace(/^[^_]*_/, "")}
                                    </span>
                                  </div>
                                </div>
                              </a>
                            )}

                            <img
                              onClick={() => {
                                checkRemoveAttachmentisFromLibrary(
                                  attachment,
                                  idx,
                                );
                              }}
                              className="attachment_cross_icon align-self-start"
                              src="/images/attachment_cross_icon.png"
                              alt="Remove"
                              style={{
                                cursor: "pointer",
                                width: "12px",
                                height: "12px",
                              }}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="d-flex flex-wrap gap-2 mt-2 align-items-start">
                {/* book and chapter */}
                <div className="d-flex w-100">
                  <div className="me-2" style={{ flex: "0 0 80%" }}>
                    <span className="poppins-semibold">BOOK & CHAPTER</span>
                    <select
                      size="md"
                      id="bookchapter"
                      className="hw_default_sub_dropdown_size form-select rounded-4 "
                      onChange={(e) => {
                        setQuestions((prev) => {
                          const updatedQuestion = {
                            ...prev[nextQuestion],
                            chapter_id: e.target.value,
                            is_question_edited: true,
                            book_id:
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("book-id"),
                          };
                          const newQuestion = [...prev];
                          newQuestion[nextQuestion] = updatedQuestion;
                          return newQuestion;
                        });
                        setUnsavedChanges(true);
                      }}
                      value={question.chapter_id}
                    >
                      <option value="">Select Book & Chapter</option>
                      {chapters?.length > 0 &&
                        chapters?.map((item) =>
                          item.bookInfo.map((book) => (
                            <optgroup
                              label={book.name}
                              key={book.id}
                              book-id={book.id}
                            >
                              {book?.chapterData &&
                                book.chapterData
                                  .slice()
                                  .sort((a, b) => {
                                    const chapterNumA = parseInt(
                                      a.chapterName.match(/\d+/)?.[0] || "0",
                                      10,
                                    );
                                    const chapterNumB = parseInt(
                                      b.chapterName.match(/\d+/)?.[0] || "0",
                                      10,
                                    );
                                    return chapterNumA - chapterNumB;
                                  })
                                  .map((chapter) => (
                                    <option
                                      key={chapter.id}
                                      book-id={book.id}
                                      book-name={book.name}
                                      value={chapter.id}
                                    >
                                      {chapter.chapterName}
                                    </option>
                                  ))}
                            </optgroup>
                          )),
                        )}
                    </select>
                  </div>

                  {/* marks */}
                  <div style={{ flex: "0 0 20%" }}>
                    <span className="poppins-semibold">MARKS</span>
                    <input
                      onChange={(e) => {
                        const inputValue = parseInt(e.target.value, 10);
                        setUnsavedChanges(true);
                        if (inputValue >= 0 && inputValue <= 200) {
                          setQuestions((prev) => {
                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              correct_score: inputValue,
                              is_question_edited: true,
                            };
                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });
                        } else if (inputValue > 200) {
                          setQuestions((prev) => {
                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              correct_score: 200,
                              is_question_edited: true,
                            };
                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });
                        } else if (inputValue < 0) {
                          setQuestions((prev) => {
                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              correct_score: 0,
                              is_question_edited: true,
                            };
                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });
                        } else {
                          setQuestions((prev) => {
                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              correct_score: null,
                              is_question_edited: true,
                            };
                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });
                        }
                      }}
                      id="marks"
                      size={"md"}
                      type="number"
                      className="form-control hw_default_sub_dropdown_size rounded-4"
                      placeholder="Enter Marks"
                      value={question?.correct_score}
                      min="0"
                      max="200"
                    />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {question?.correct_score === null || ""
                        ? "Marks should be > 0"
                        : ""}
                    </span>
                  </div>
                </div>

                <div className="d-flex w-100 gap-2 mt-2">
                  {/* level of difficulty */}
                  <div style={{ flex: "0 0 33%" }}>
                    <span className="poppins-semibold">
                      LEVEL OF DIFFICULTY
                    </span>
                    <select
                      onChange={(e) => {
                        setQuestions((prev) => {
                          const updatedQuestion = {
                            ...prev[nextQuestion],
                            difficulty_level: e.target.value,
                            is_question_edited: true,
                          };
                          const newQuestion = [...prev];
                          newQuestion[nextQuestion] = updatedQuestion;
                          return newQuestion;
                        });
                        setUnsavedChanges(true);
                      }}
                      value={question.difficulty_level}
                      className="form-select hw_default_sub_dropdown_size rounded-4"
                      id="difficultyLevels"
                      size={"md"}
                    >
                      <option value="">Select Difficulty</option>
                      {difficultyLevels &&
                        (selectedBox === "adaptive" ||
                        selectedBox?.adaptive ||
                        selectedBox?.isAdaptive
                          ? difficultyLevels.filter(
                              (level) => level.name !== "None",
                            )
                          : difficultyLevels
                        ).map((difficultyLevel, index) => (
                          <option key={index} value={difficultyLevel.id}>
                            {difficultyLevel.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* skills */}
                  <div style={{ flex: "0 0 33%" }}>
                    <span className="poppins-semibold d-flex align-items-center">
                      SKILLS
                      <Info
                        size={16}
                        color="blue"
                        style={{ cursor: "pointer", marginLeft: "8px" }}
                        onClick={() => setClick(true)}
                        title="More details"
                      />
                    </span>
                    <select
                      onChange={(e) => {
                        const selectedSkillId = e.target.value;
                        const selectedSkill = skillsWithDomainId.find(
                          (skill) => skill.id === selectedSkillId,
                        );
                        const domainId = selectedSkill?.domain_id || null;

                        setQuestions((prev) => {
                          const updatedQuestion = {
                            ...prev[nextQuestion],
                            skill_id: selectedSkillId,
                            domain_id: domainId,
                            is_question_edited: true,
                          };
                          const newQuestion = [...prev];
                          newQuestion[nextQuestion] = updatedQuestion;
                          return newQuestion;
                        });

                        setUnsavedChanges(true);
                      }}
                      value={question.skill_id}
                      className="form-select hw_default_sub_dropdown_size  rounded-4"
                      id="skills"
                      size={"md"}
                    >
                      <option value="">Select Skill</option>
                      {skillToDomainNameMap &&
                        (selectedBox === "adaptive" ||
                        selectedBox?.adaptive ||
                        selectedBox?.isAdaptive
                          ? skillsWithDomainId?.filter(
                              (skill) => skill.name !== "None",
                            )
                          : skillsWithDomainId
                        )?.map((skill) => (
                          <option key={skill.id} value={skill.id}>
                            {skill.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div style={{ flex: "0 0 33%" }}>
                    <span className="poppins-semibold">TYPE OF QUESTION</span>

                    {/* 🐛 TEMP DEBUG - remove after fix */}
                    {console.log("TYPES DEBUG", {
                      typesLen: types?.length,
                      typeId: question?.type_id,
                      typeIdType: typeof question?.type_id,
                      firstTypeId: types?.[0]?.id,
                      firstTypeIdType: typeof types?.[0]?.id,
                      matched: types?.find(
                        (t) => String(t.id) === String(question?.type_id),
                      ),
                      hasDesc: hasDescriptiveAutoAssessment,
                    })}

                    <select
                      onChange={(e) => {
                        const selectedOption =
                          e.target.options[e.target.selectedIndex];
                        const isManuallyGraded =
                          selectedOption.getAttribute(
                            "data-is-manually-graded",
                          ) === "true";

                        setQuestions((prev) => {
                          const current = prev[nextQuestion];
                          let updatedQuestion;
                          setUnsavedChanges(true);

                          if (isManuallyGraded) {
                            updatedQuestion = {
                              ...current,
                              type_id: e.target.value,
                              is_question_edited: true,
                              question_type: String(isManuallyGraded),
                              options: [],
                              correct_answers: [
                                {
                                  reason_for_answer: {
                                    explanation: null,
                                    attachments: null,
                                  },
                                },
                              ],
                            };
                            if (hasDescriptiveAutoAssessment) {
                              updatedQuestion.subjective_evaluation = {
                                enabled: false,
                                expectedAnswer: "",
                                rubric: [],
                                ...(current.subjective_evaluation || {}),
                              };
                            } else {
                              delete updatedQuestion.subjective_evaluation;
                            }
                          } else {
                            updatedQuestion = {
                              ...current,
                              type_id: e.target.value,
                              is_question_edited: true,
                              question_type: String(isManuallyGraded),
                              options: [
                                { key: "A", value: null },
                                { key: "B", value: null },
                              ],
                            };
                            delete updatedQuestion.subjective_evaluation;
                          }

                          const newQuestion = [...prev];
                          newQuestion[nextQuestion] = updatedQuestion;
                          return newQuestion;
                        });
                      }}
                      value={
                        question?.type_id != null && question?.type_id !== ""
                          ? String(question.type_id)
                          : ""
                      }
                      id="questiontype"
                      size={"md"}
                      className="form-select hw_default_sub_dropdown_size rounded-4"
                      disabled={(() => {
                        const isAdaptiveMode =
                          selectedBox === "adaptive" ||
                          selectedBox?.adaptive ||
                          selectedBox?.isAdaptive;

                        const isAutoEvalMode =
                          selectedBox === "auto-evaluate" ||
                          selectedBox?.autoEvaluate === true;

                        if (isAdaptiveMode) return true; // always disabled
                        if (isAutoEvalMode)
                          return !hasDescriptiveAutoAssessment; // disabled if flag OFF
                        return false; // normal → enabled
                      })()}
                    >
                      <option value="">Select QuestionType</option>
                      {(() => {
                        const isAutoMode =
                          selectedBox === "adaptive" ||
                          selectedBox === "auto-evaluate" ||
                          selectedBox?.adaptive ||
                          selectedBox?.isAdaptive ||
                          selectedBox?.autoEvaluate;

                        const visibleTypes = (() => {
                          if (hasDescriptiveAutoAssessment) return types || [];
                          if (isAutoMode)
                            return (types || []).filter(
                              (t) => t.name === "MCQ",
                            );
                          return types || [];
                        })();

                        return visibleTypes.map((type, index) => (
                          <option
                            key={index}
                            value={String(type.id)}
                            data-is-manually-graded={String(
                              type?.is_manually_graded,
                            )}
                          >
                            {type.name}
                          </option>
                        ));
                      })()}
                    </select>
                  </div>
                </div>
              </div>
              <div className=" col-12 mt-4 d-flex align-items-start flex-column">
                <div className="col-12 d-flex align-items-start gap-4">
                  {/* {(componentType == ComponentType.ASSESSMENT || componentType == ComponentType.HOMEWORK) &&
                                <div className=" hw_default_dropdown_size">
                                    <input
                                        onChange={() => {
                                            setQuestions((prev) => {
                                                const updatedQuestion = {
                                                    ...prev[nextQuestion],
                                                    is_question_edited: true,
                                                    is_mandatory: !question?.is_mandatory,
                                                };
                                                const newQuestion = [...prev];
                                                newQuestion[nextQuestion] = updatedQuestion;
                                                return newQuestion;
                                            })
                                            setUnsavedChanges(true)
                                        }
                                        }

                                        type="checkbox"
                                        checked={question?.is_mandatory}
                                    />
                                    &nbsp;
                                    <span>Mandatory question</span>
                                </div>
                            } */}
                  {componentType === ComponentType.QUESTION_BANK && (
                    <div className=" hw_default_dropdown_size">
                      <input
                        onChange={(e) => {
                          const checked = e.target.checked;

                          setQuestions((prev) => {
                            const current = prev[nextQuestion].add_to;

                            let add_to;
                            if (checked) {
                              // Homework checked
                              add_to =
                                current === "assessment" ? "all" : "homework";
                            } else {
                              // Homework unchecked
                              add_to = current === "all" ? "assessment" : null;
                            }

                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              is_question_edited: true,
                              add_to,
                            };

                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });

                          setUnsavedChanges(true);
                        }}
                        type="checkbox"
                        id="add_to_hw"
                        checked={
                          question?.add_to === "homework" ||
                          question?.add_to === "all"
                        }
                      />
                      &nbsp;
                      <span className="poppins-semibold">Add for Homework</span>
                    </div>
                  )}
                  {componentType === ComponentType.QUESTION_BANK && (
                    <div className=" hw_default_dropdown_size">
                      <input
                        onChange={(e) => {
                          const checked = e.target.checked;

                          setQuestions((prev) => {
                            const current = prev[nextQuestion].add_to;

                            let add_to;
                            if (checked) {
                              // Assessment checked
                              add_to =
                                current === "homework" ? "all" : "assessment";
                            } else {
                              // Assessment unchecked
                              add_to = current === "all" ? "homework" : null;
                            }

                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              is_question_edited: true,
                              add_to,
                            };

                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });

                          setUnsavedChanges(true);
                        }}
                        type="checkbox"
                        id="add_to_ass"
                        checked={
                          question?.add_to === "assessment" ||
                          question?.add_to === "all"
                        }
                      />
                      &nbsp;
                      <span className="poppins-semibold">
                        Add for Assessment
                      </span>
                    </div>
                  )}
                  {componentType === ComponentType.QUESTION_BANK && (
                    <div className=" hw_default_dropdown_size">
                      <input
                        onChange={() => {
                          setQuestions((prev) => {
                            const updatedQuestion = {
                              ...prev[nextQuestion],
                              is_question_edited: true,
                              add_to_mock: !question?.add_to_mock,
                            };
                            const newQuestion = [...prev];
                            newQuestion[nextQuestion] = updatedQuestion;
                            return newQuestion;
                          });
                          setUnsavedChanges(true);
                        }}
                        id="add_to_qsbank"
                        type="checkbox"
                        checked={question?.add_to_mock}
                      />
                      &nbsp;
                      <span className="poppins-semibold">Add for Mock</span>
                    </div>
                  )}
                </div>
                {componentType === ComponentType.QUESTION_BANK && (
                  <div className="col-12 mt-1 text-warning ">
                    <small>
                      *Selection will add question to library so that you can
                      re-use it through "Add from School Library" during
                      creation.
                    </small>
                  </div>
                )}
              </div>

              {!isValidFileType && (
                <p id="errorMsg">
                  Please upload a file with a valid extension (pdf, jpg, jpeg,
                  png, pptx, ppt, mp3, mp4), Max Limit = 5.
                </p>
              )}
              {question.question_type !== "" &&
              question.question_type === "false" ? (
                <CreateMcq
                  nextQuestion={nextQuestion}
                  question={question}
                  setQuestions={setQuestions}
                />
              ) : (
                question.question_type !== "null" && (
                  <CreateUploadType
                    nextQuestion={nextQuestion}
                    question={question}
                    setQuestions={setQuestions}
                    componentType={componentType}
                    hasDescriptiveAutoAssessment={hasDescriptiveAutoAssessment}
                    selectedBox={selectedBox}
                  />
                )
              )}
            </div>
          )}

          {click && <Guides setClick={setClick} />}

          {showErrorInputField && (
            <CheckValidationInput
              getErrorMsg={getErrorMsg}
              setShowErrorInputField={setShowErrorInputField}
            />
          )}
          {openQuestionsPopup && (
            <QuestionTypePopup setOpenQuestionsPopup={setOpenQuestionsPopup} />
          )}
          {mideaviewer && (
            <PdfViewer
              setMideaviewer={setMideaviewer}
              attachment={responseAttach}
            />
          )}
        </div>
      </div>

      {zoomedAttachment && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <button
            onClick={() => setZoomedAttachment(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "transparent",
              border: "none",
              fontSize: "2rem",
              color: "white",
              cursor: "pointer",
            }}
            aria-label="Close"
          >
            &times;
          </button>

          <img
            src={zoomedAttachment}
            alt="Zoomed Attachment"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 10px #000",
            }}
          />
        </div>
      )}
    </>
  );
};

export default DefaultQuestion;
